import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import Api from './state/Api';
import QuoteView from "./QuoteView"
import { EmailListComp } from "./components/AgComponents"
import { Columns, Col, Col2, Col3, Col4, Col6, Col12 } from "./Controls"
import { toEmailStore, ccEmailStore, quoteDataRec, configStore, modalStore } from "./state/CommonState"
import { useSnapshot } from 'valtio';

export default function QuoteViewMain() {
    const [space, setSpace] = useState('')
    const getExchangerates = async( ) =>{
        await Api.getExchangerates()
      }
    useLayoutEffect(() => {
        getExchangerates()
        setTimeout(() => {
            setSpace(' ')
        }, 300);
    }, [])

       
    
    return (
        <>
        {space}
            <Columns>
                <Col6>
                    <EmailListComp label='TO - email ids' emailStore={toEmailStore} />
                </Col6>
                <Col6>
                    <EmailListComp label='CC - email ids' emailStore={ccEmailStore} />
                </Col6>
            </Columns>
            <QuoteView />
            
            
              
            <button className="button is-danger" 
            onClick={(e) => {
                    Api.sendMail()
                    if(toEmailStore.emails.length < 1 ){
                        e.target.disabled = false
                    }else{
                        e.target.disabled = true
                    }
                    
                }}>
                    Send mail
                </button>
            
            {/*<button className="button is-warning" style={{marginLeft: '10px'}} onClick={() => {
                Api.sendMailwithPDF()
            }}>
                Send PDF over mail
        </button>*/}
        </>
    )
}
